import {LevelAssessmentModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentModel";
import type LevelAssessmentTaskResponse from "~~/package/apis/levelAssessment/response/LevelAssessmentTaskResponse";
import {TaskModel} from "~~/package/mapper/learning/model/TaskModel";
import {MultipleChoiceResultModel} from "~~/package/mapper/learning/model/MultipleChoiceResultModel";
import {useLearningStore} from "~/store/learning/learningStore";
import {LevelAssessmentResultListModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentResultListModel";

export class LevelAssessmentHelper {
    public static mappingLevelAssessmentData(levelAssessment: LevelAssessmentTaskResponse): TaskModel {
        useLearningStore().taskSolveTime = levelAssessment.taskSolveTime ? levelAssessment.taskSolveTime : 0;
        return TaskModel.create({
            ...levelAssessment,
            id: levelAssessment.id,
            submitCode: levelAssessment.submissionCode ? levelAssessment.submissionCode : levelAssessment.submitAnswer,
            multipleChoiceQuestion: {
                ...levelAssessment.multipleChoiceQuestion,
                multipleChoiceResult: new MultipleChoiceResultModel()
            }
        });
    }

    public static mappingLevelAssessmentInfo(info: LevelAssessmentModel): LevelAssessmentModel {
        return LevelAssessmentModel.create(info);
    }

    public static mappingLevelAssessmentResult(result: LevelAssessmentResultListModel): LevelAssessmentResultListModel {
        return LevelAssessmentResultListModel.create(result);
    }
}
